module.exports = __webpack_public_path__ + "img/marker-icon-blue-waves.8d152c07.png";